import { createFileRoute } from "@tanstack/react-router";

import { StockPage } from "../../../workspaces/supply/pages/StockPage";

export const Route = createFileRoute("/_console/p/$org/$project/supply/")({
  component: StockPage,
});
